export default __webpack_public_path__ + "img/chamption-54ca8836.png";